import { render, staticRenderFns } from "./DateEditor.vue?vue&type=template&id=1c19b298&"
import script from "./DateEditor.vue?vue&type=script&lang=js&"
export * from "./DateEditor.vue?vue&type=script&lang=js&"
import style0 from "./DateEditor.vue?vue&type=style&index=0&id=1c19b298&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports